module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [(_vm.phase === 'gameOver') ? _c('div', [_vm._v(_vm._s(_vm.name))]) : _c('div', [_c('strong', [_vm._v("Current Phase: ")]), _vm._v(_vm._s(_vm.phase) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26a9db06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 194
// module chunks = 0